import { Chip } from '@mui/material'
import { ProductMasterBatchJobStatusEnum } from '@ulysses-inc/harami_api_client'
import { FC } from 'react'

const getStatusDisplayConfig = (status: ProductMasterBatchJobStatusEnum) => {
  switch (status) {
    case ProductMasterBatchJobStatusEnum.Error:
      return {
        label: 'エラー',
        color: 'error' as const,
      }
    case ProductMasterBatchJobStatusEnum.Succeeded:
      return {
        label: '成功',
        color: 'success' as const,
      }
    default:
      return {
        label: '進行中',
        color: 'default' as const,
      }
  }
}

const StatusChip: FC<{ status: ProductMasterBatchJobStatusEnum }> = ({
  status,
}) => {
  const statusDisplayConfig = getStatusDisplayConfig(status)

  return (
    <Chip
      label={statusDisplayConfig.label}
      color={statusDisplayConfig.color}
      size="small"
      variant="filled"
    />
  )
}

export default StatusChip
